import moment from 'moment';
import { SelectedType } from '../searchDates.types';
import { searchConstants } from '../../../../search-utils/searchConstants';

export function getSelectedDateSelectorFromState(
  from?: string,
  to?: string,
): SelectedType {
  let selectedType: SelectedType;
  if (!from && !to) {
    selectedType = 'all';
  } else if (
    !!from &&
    parseInt(from, 10) === searchConstants.years.yearNow &&
    !to
  ) {
    selectedType = 'year_now';
  } else if (
    !!from &&
    parseInt(from, 10) === searchConstants.years.yearNowMinusOne &&
    !to
  ) {
    selectedType = 'year_now_minus_one';
  } else if (
    !!from &&
    parseInt(from, 10) === searchConstants.years.yearNowMinusFour &&
    !to
  ) {
    selectedType = 'year_now_minus_four';
  } else if (
    moment(from, 'DD/MM/YYYY').isValid() &&
    moment(to, 'DD/MM/YYYY').isValid() &&
    from === to
  ) {
    selectedType = 'date_picker_day';
  } else if (from && to) {
    selectedType = 'date_picker';
  } else {
    selectedType = 'all';
  }

  return selectedType;
}
